import { Tooltip } from "antd"
import { TriangleAlertSmallIcon } from "components/ui/icons/Warning/TriangleAlertSmallIcon"
import { defaultTooltipStyles, getSidebarTooltipContainer } from "components/ui/customWebviewer/shared/shadowTooltip"
import { MODEL_NUMBER_MISMATCH_LABEL } from "components/ui/customWebviewer/shared/ModelNumberMismatchIndicator/modelNumberMismatch.helpers"
import style from "./ModelNumberMismatchIndicator.module.scss"

type Props = {
	/** The hover text for this level (object / eref / page). */
	message: string
	className?: string
}

/** REQ-250 warning: a model number that has no price for the selected series. */
export const ModelNumberMismatchIndicator = ({ message, className }: Props) => (
	<Tooltip title={message} placement="top" getPopupContainer={getSidebarTooltipContainer} styles={defaultTooltipStyles}>
		<span className={className ? `${style.indicator} ${className}` : style.indicator}>
			<TriangleAlertSmallIcon title={MODEL_NUMBER_MISMATCH_LABEL} />
		</span>
	</Tooltip>
)
